module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "SafeMath",
	"sourceName": "contracts/levels/P2PSwapper.sol",
	"abi": [],
	"bytecode": "0x60566023600b82828239805160001a607314601657fe5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220b10a7f312acb51af37a2e65480ad0a74e999ac6cbf1239ba49215740de88743e64736f6c634300060c0033",
	"deployedBytecode": "0x73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220b10a7f312acb51af37a2e65480ad0a74e999ac6cbf1239ba49215740de88743e64736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/P2PSwapper.sol/SafeMath.json
// module id = 1595
// module chunks = 0